import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { SalesGateway } from "../SalesStatistics/SaleRecord.ts";
import { StripeOrderStatus } from "../../Stripe/StripeOrderDTO.ts";
import { OrdersListPage } from "../OrdersList/OrdersListPage.tsx";
import { useOrdersListUrlState } from "../OrdersList/useOrdersListUrlState.ts";
import { useGetAllStripeOrders } from "./useGetAllStripeOrders.ts";
import { toOrdersExportApiParams } from "../OrdersList/OrdersListQuery.ts";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { downloadCsvFile } from "../../UI/Utils/downloadCsvFile.ts";
import { AdminStripeOrderTable } from "./AdminStripeOrderTable.tsx";

const STRIPE_ORDER_STATUSES = Object.values(StripeOrderStatus);

export function StripeOrdersListScreen({ readOnly }: { readOnly?: boolean }) {
  const { query, setSearch, setSort, setFilters, toPage } =
    useOrdersListUrlState(STRIPE_ORDER_STATUSES);
  const { orders, total, isLoading, error, mutate } =
    useGetAllStripeOrders(query);
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();

  if (isLoading) return <FullPageLoading />;

  return (
    <OrdersListPage
      title="Ordini Stripe"
      searchPlaceholder="Cerca per cliente, partecipanti, ID ordine, importo o dati di fatturazione"
      query={query}
      total={total}
      hasError={!!error}
      statisticsGateway={readOnly ? undefined : SalesGateway.Stripe}
      onSearch={setSearch}
      onClearFilters={() => setFilters({})}
      onChangePage={toPage}
      csvExport={
        readOnly
          ? undefined
          : {
              allOrdersDescription: "tutti gli ordini Stripe",
              download: () =>
                downloadCsvFile(createAxiosInstance(), {
                  url: "/admin/orders/export/csv",
                  params: toOrdersExportApiParams(query),
                  fileNamePrefix: "ordini-stripe",
                }),
            }
      }
    >
      <AdminStripeOrderTable
        orders={orders}
        readOnly={readOnly}
        query={query}
        onSort={setSort}
        onFiltersChange={setFilters}
        onOrdersChanged={() => mutate()}
      />
    </OrdersListPage>
  );
}
